import { notification } from "antd";

export const openNotificationWithIcon = (
  type: "success" | "error" | "info",
  title: string,
  description: string
) => {
  notification[type]({
    message: title,
    description,
  });
};
